<script>
import TheMeetingCommentForStatementDialog from "../Dialogs/Meeting/TheMeetingCommentForStatementDialog.vue";

import TheMeetingScholarshipHeaderCard from "../Cards/Meeting/TheMeetingScholarshipHeaderCard.vue";
import TheMeetingScholarshipParameterCard from "../Cards/Meeting/TheMeetingScholarshipParameterCard.vue";
import TheMeetingScholarshipStatementsCard from "../Cards/Meeting/TheMeetingScholarshipStatementsCard.vue";
import TheMeetingEditParamsDialog from "../Dialogs/Meeting/TheMeetingEditParamsDialog.vue";
const TheMeetingShowStatementDialog = () => import("../Dialogs/Meeting/TheMeetingShowStatementDialog.vue");
import TheMeetingVotingDialog from "../Dialogs/Meeting/TheMeetingVotingDialog.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {createConsumer} from "@rails/actioncable";
//prod wss://cabinet.amursu.ru/cable
//dev ws://0.0.0.0:3000/cable

const urlWebsocket = 'wss://cabinet.amursu.ru/cable'

export default {
  name: "TheMeetingScholarshipContainer",

  components: {
    TheMeetingEditParamsDialog,
    TheMeetingScholarshipHeaderCard,
    TheMeetingScholarshipParameterCard,
    TheMeetingScholarshipStatementsCard,
    TheMeetingShowStatementDialog,
    TheMeetingCommentForStatementDialog,
    TheMeetingVotingDialog,
  },

  watch: {
    meeting() {
      if(!_.isEmpty(this.meeting)) {
        this.cableMeeting.subscriptions.create({
          channel: "ScholarshipMeetingChannel",
          meeting: this.meeting.id
        }, {
          connected: function() {
            console.log("connected");
          },
          disconnected: function() {
            console.log("disconnected");
          },
          received: (data) => {
            this.getStatements();
            if(!_.isEmpty(this.statement)) {
              this.getStatement(this.statement.id)
            }
          }
        })
      } else {
        this.cableMeeting.disconnect();
        this.cableMeeting = createConsumer(urlWebsocket);
      }
    },

  },

  mounted() {
    this.getMeetingsFromServer();
    this.cableMeeting = createConsumer(urlWebsocket);
  },

  data() {
    return {
      showStatement: false,
      loadingStatements: true,
      loadingMeeting: false,
      loadingMeetings: true,

      cableMeeting: null,

      visibleEditMeetingDialog: false,
    };
  },

  beforeDestroy() {
    this.setMeetings([]);
    this.setMeeting({});
    this.setStatements([]);
    this.setStatement({});
    this.cableMeeting.disconnect();
    this.cableMeeting = null;
  },


  computed: {
    ...mapState({
      statement: state => state.scholarship_competition.statement,
      meetings: state => state.scholarship_meeting.meetings,
      meeting: state => state.scholarship_meeting.meeting,
      sendSnackbar: state => state.scholarship_meeting.sendSnackbar,
    }),

    isMeetingEmpty() {
      return _.isEmpty(this.meeting);
    },
  },

  methods: {

    ...mapActions({
      getMeeting: "scholarship_meeting/getMeeting",
      getMeetings: 'scholarship_meeting/getMeetings',
      getStatements: "scholarship_competition/getStatements",
      getStatement: 'scholarship_competition/getStatement',
    }),

    ...mapMutations({
      setSendSnackbar: 'scholarship_meeting/setSendSnackbar',
      setMeetings: 'scholarship_meeting/setMeetings',
      setMeeting: 'scholarship_meeting/setMeeting',
      setStatements: 'scholarship_competition/setStatements',
      setStatement: 'scholarship_competition/setStatement',
    }),

    async getMeetingsFromServer() {
      await this.getMeetings();
      this.loadingMeetings = false;
    },

    async getMeetingFromServer(id) {
      this.loadingStatements = true;

      this.setMeeting(_.find(this.meetings, meeting => meeting.id === id));
      await this.getStatements();

      this.loadingStatements = false;
    },

    closeMeetingDashboard() {
      this.setMeeting({});
      this.setStatements([]);
    },

  },

}
</script>

<template>

  <div v-if="isMeetingEmpty">

    <v-container fluid v-if="meetings.length > 0">
      <v-card
        outlined
        class="rounded-xl mb-3"
      >
        <v-card-title class="text-center">Повышенная государственная академическая стипендия</v-card-title>
      </v-card>
      <v-row>
        <v-col
          v-for="meeting in meetings"
          :key="meeting.id"
          cols="12"
          md="4"
        >
          <v-card
            outlined
            flat
            class="rounded-xl"
          >
            <v-card-title class="text-center">
              {{meeting.department.name}}({{meeting.department.abbreviation}})
            </v-card-title>

            <v-card-text class="text-center">
              <p> Семестр: {{meeting.semester}} </p>
              <p> Учебный год: {{meeting.study_year}} </p>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                small
                class="rounded-xl white--text"
                color="teal darken-3"
                :loading="loadingMeeting"
                @click="getMeetingFromServer(meeting.id)"
              >
                Выбрать
              </v-btn>
            </v-card-actions>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid v-else>
      <v-sheet class="d-flex align-center justify-center">
        <span class="text-h5">Список пуст</span>
      </v-sheet>
    </v-container>

  </div>

  <div v-else>

    <v-container fluid>

      <v-row>
        <v-col>
          <the-meeting-scholarship-header-card
            @backDashboard="closeMeetingDashboard"
          />
        </v-col>
      </v-row>

      <v-row>

        <v-col  cols="12" md="4">
          <the-meeting-scholarship-parameter-card
            :loading="loadingMeeting"
            @openEditMeeting="visibleEditMeetingDialog = true"
          />
        </v-col>

        <v-col cols="12" md="8">
          <the-meeting-scholarship-statements-card
            :loading="loadingStatements"
          />
        </v-col>

      </v-row>

      <the-meeting-show-statement-dialog/>

      <the-meeting-comment-for-statement-dialog/>

      <the-meeting-voting-dialog/>

      <the-meeting-edit-params-dialog :visible="visibleEditMeetingDialog" @close="visibleEditMeetingDialog = false"/>

      <v-snackbar
        :value="sendSnackbar"
        @input="setSendSnackbar(!sendSnackbar)"
        :timeout="2000"
        color="teal darken-3"
        class="white--text text-center"
      >
        <v-icon small left>fa-check-circle</v-icon>Действие было успешно выполнено
      </v-snackbar>

    </v-container>

  </div>



</template>

<style scoped>
</style>